const EXITED = 'exited';

export { EXITED as E };
//# sourceMappingURL=Transition-50ee24f6.js.map
